import React from "react"
import { motion } from "framer-motion"
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa"

export default function ContactInfo() {
  const info = [
    {
      id: 1,
      icon: <FaMapMarkerAlt />,
      title: "Address",
      text: "Centre Spa Land Saphir Palace & Spa, Hammamet, Tunisia",
    },
    {
      id: 2,
      icon: <FaPhoneAlt />,
      title: "Téléphone",
      text: "+216 97 902 051",
    },
    {
      id: 3,
      icon: <FaEnvelope />,
      title: "Email",
      text: "Fredj_bannour@yahoo.fr",
    },
    {
      id: 4,
      icon: <FaClock />,
      title: "Ouvert",
      text: "Lun - Dim: 9:00 - 18h:00",
    },
  ]

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {info.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: index * 0.15 }}
              viewport={{ once: true }}
              className="bg-[#f9f6f1] rounded-[30px] p-8 shadow-lg hover:shadow-2xl transition-all duration-500 text-center"
            >
              {/* Icon */}
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-[#b8955d] text-white text-2xl shadow-md">
                {item.icon}
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-[#111111] mt-6">
                {item.title}
              </h3>

              {/* Text */}
              <p className="text-gray-600 mt-3 text-sm md:text-base leading-relaxed">
                {item.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}